import React from 'react';
import { block } from '../../utils/cn';
import { LayerIcon } from '../LayerIcon/LayerIcon';
import './LayerLogo.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('layer-logo');
export function LayerLogo(_ref) {
  var icon = _ref.icon,
    layer = _ref.layer,
    type = _ref.type,
    subtype = _ref.subtype,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: b({
      type: layer,
      size: size
    }, className),
    children: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/_jsx(LayerIcon, {
      layer: layer,
      type: type,
      subtype: subtype,
      size: size
    })
  });
}
// #sourceMappingURL=LayerLogo.js.map